<template>
    <v-textarea 
        v-model="localValue" 
        :label="label" 
        :rules="rules"
        :hide-details="hidedetails"
        density="compact"
        rows="3"
        variant="outlined" 
    />
</template>

<script>

export default {

    props: {
        hidedetails: Boolean,
        label: String,
        rules: Array,
        value: String
    },

    data() {
        return {
            localValue: this.value
        };
    },
}

</script>
